(() => {
  if (window.vaJournalIndex) {
    window.vaJournalIndex.init(document);
    return;
  }
  const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observers = new Set();
  const animations = new Set();
  const motionAllowed = () => !motionPreference.matches && !document.documentElement.classList.contains('va-no-motion');
  const preservePreview = (scope) => {
    const themeId = scope.dataset.previewThemeId;
    if (!themeId) return;
    scope.querySelectorAll('a[href]').forEach((link) => {
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#')) return;
      try {
        const url = new URL(href, window.location.href);
        if (url.origin !== window.location.origin) return;
        url.searchParams.set('preview_theme_id', themeId);
        link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
      } catch (error) {
        return;
      }
    });
  };
  const init = (container) => {
    const scopes = [];
    if (container.matches?.('[data-va-journal]')) scopes.push(container);
    container.querySelectorAll?.('[data-va-journal]').forEach((scope) => scopes.push(scope));
    scopes.forEach((scope) => {
      if (scope.dataset.journalReady === 'true') return;
      scope.dataset.journalReady = 'true';
      preservePreview(scope);
      if (!motionAllowed() || !('IntersectionObserver' in window) || typeof Element.prototype.animate !== 'function') return;
      const elements = Array.from(scope.querySelectorAll('[data-va-journal-reveal]'));
      let remaining = elements.length;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          remaining -= 1;
          if (motionAllowed()) {
            const animation = entry.target.animate(
              [{ opacity: .7, transform: 'translateY(18px)' }, { opacity: 1, transform: 'translateY(0)' }],
              { duration: 570, easing: 'cubic-bezier(.2,.7,.2,1)' }
            );
            animations.add(animation);
            animation.finished.then(() => animations.delete(animation)).catch(() => animations.delete(animation));
          }
          if (remaining <= 0) {
            observer.disconnect();
            observers.delete(observer);
          }
        });
      }, { threshold: .06, rootMargin: '0px 0px -15px 0px' });
      observers.add(observer);
      elements.forEach((element) => observer.observe(element));
    });
  };
  motionPreference.addEventListener('change', () => {
    if (!motionPreference.matches) return;
    observers.forEach((observer) => observer.disconnect());
    observers.clear();
    animations.forEach((animation) => animation.cancel());
    animations.clear();
  });
  window.vaJournalIndex = { init };
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  init(document);
})();
